<template>
    <i
    class="wack"
    :class="['wack-'+type ]"
    :style="{ 'font-size': size + 'px' || '16px', color: color }"
  ></i>
</template>
<script>
export default {
   props: {
    type: {
      type: String,
      default: ""
    },
    size: {
      type: [String, Number],
      default: ""
    },
    color: {
      type: String,
      default: ""
    }
  },
}
</script>

<style scoped lang='scss'>
@font-face {
  font-family: "wack";
  src:   url('//at.alicdn.com/t/font_992732_muo86xkru9.ttf?t=1638849065545') format('truetype');

}

.wack-kaiqi3:before {
  content: "\e6a4";
}
i {
  font-size: 17px;
}
.wack {
  display: block;
  font-family: "wack" !important;
  font-size: 17px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.wack-shangchuantupian:before {
  content: "\e626";
}
.wack-shijian2:before {
  content: "\e6f7";
}

.wack-gengduo:before {
  content: "\e6f8";
}

.wack-dingwei1:before {
  content: "\e704";
}
.wack-a-zu248:before {
  content: "\e6f1";
}

.wack-a-zu249:before {
  content: "\e6f3";
}

.wack-a-zu77:before {
  content: "\e6f4";
}

.wack-a-zu37:before {
  content: "\e6f5";
}


.wack-tuichu:before {
  content: "\eb44";
}

.wack-shijian1:before {
  content: "\e6e3";
}

.wack-dizhi5:before {
  content: "\e6e4";
}

.wack-xuexiao4:before {
  content: "\e6f0";
}

.wack-caidan1:before {
  content: "\ed43";
}

.wack-sousuoliebiao:before {
  content: "\e811";
}
.wack-tubiaozhizuomoban_canbaorenshenfenleibie_ditu:before {
  content: "\e6e1";
}
.wack-jiekoupeizhi:before {
  content: "\e990";
}
.wack-ditu1:before {
  content: "\e6e0";
}
.wack-jiantou:before {
  content: "\e655";
}

.wack-caidan:before {
  content: "\f314";
} 
.wack-guanguangche:before {
  content: "\e708";
}
.wack-xishoujian:before {
  content: "\e6dc";
}

.wack-jiudian:before {
  content: "\e6dd";
}

.wack-yiyuan:before {
  content: "\e7aa";
}

.wack-canyin:before {
  content: "\e6df";
}

.wack-tingchechang2:before {
  content: "\e6d8";
}

.wack-yun1:before {
  content: "\e6aa";
}

.wack-xue:before {
  content: "\e6ab";
}

.wack-lei:before {
  content: "\e6ad";
}

.wack-feng:before {
  content: "\e6ae";
}

.wack-qing:before {
  content: "\e752";
}
.wack-yuyin:before {
  content: "\e697";
}
.wack-kaiguanswitch-jibenzhuangtai-ximiezhuangtai:before {
  content: "\e69e";
}
.wack-kaiguanguanbi:before {
  content: "\e6ce";
}

.wack-kaiguan_:before {
  content: "\e69d";
}
.wack-fanhui:before {
  content: "\e65b";
  font-size: 24px !important;
  position: absolute;
  left: 10px;
  top: 0
}
.wack-dianhua8:before {
  content: "\e679";
}

.wack-ditu:before {
  content: "\e7bf";
}

.wack-gongnengshengji:before {
  content: "\e698";
}

.wack-qita:before {
  content: "\e699";
}
.wack-fankui:before {
  content: "\e8db";
}
.wack-jianjie1:before {
  content: "\e694";
}
.wack-test:before {
  content: "\e676";
}
.wack-switch-open2:before {
  content: "\e677";
}
.wack-guan-copy:before {
  content: "\e67f";
}
.wack-kaiqi:before {
  content: "\e67b";
}
.wack-dingweiweizhi-copy:before {
  content: "\e675";
}
.wack-youkezhongxin:before {
  font-size: 18px;
  content: "\e6d9";
}
.wack-dizhi3:before {
  content: "\e673";
}

.wack-shijian:before {
  content: "\e6a6";
}
.wack-dizhi4:before {
  content: "\e674";
}
.wack-guanbi1:before {
  content: "\e629";
  font-size: 28px;
}
.wack-guanbi1 {
  position: absolute;
  right: 13px;
  top: 0px;
}
.wack-jianjie:before {
  content: "\e670";
}

.wack-bangzhu:before {
  content: "\e671";
}
.wack-jingdian:before {
  font-size: 18px;
  content: "\e693";
}
.wack-churukou-copy:before {
  font-size: 18px;
  content: "\e66d";
}
.wack-luxian:before {
  font-size: 18px;
  content: "\e6a8";
}
.wack-shoupiao:before {
  font-size: 18px;
  content: "\e66e";
}
.wack-luxian2:before {
  content: "\e6a7";
}
.wack-ziyuan:before {
  content: "\e69c";
}
.wack-fuwuaixin:before {
  content: "\e69b";
}

.wack-luxian1:before {
  content: "\e6d4";
}
.wack-fuwu2:before {
  content: "\e690";
}
.wack-bofangzhong1:before {
  content: "\e692";
}
.wack-daohang1:before {
  content: "\e748";
}
.wack-bofang:before {
  content: "\e691";
}

.wack-daohang:before {
  content: "\e68f";
}
.wack-duigou:before {
  content: "\e684";
}

.wack-laba:before {
  content: "\e685";
}
.wack-up2:before {
  content: "\e680";
}
.wack-sousuo1:before {
  content: "\e683";
}
.wack-up:before {
  content: "\e681";
}
.wack-youkezhongxin:before {
  font-size: 18px;
  content: "\e6d9";
}

.wack-jingdian:before {
  font-size: 18px;
  content: "\e693";
}
.wack-churukou-copy:before {
  font-size: 18px;
  content: "\e66d";
}
.wack-luxian:before {
  font-size: 18px;
  content: "\e6a8";
}
.wack-shoupiao:before {
  font-size: 18px;
  content: "\e66e";
}

.wack-zhibo:before {
  font-size: 18px;
  content: "\e8cd";
}
.wack-chenggong:before {
  font-size: 18px;
  content: "\e66a";
}

.wack-shibai:before {
  font-size: 18px;
  content: "\e950";
}
.wack-guanbi1:before {
  content: "\e629";
}
.wack-daohangx:before {
  content: "\e76a";
}
.wack-kaiqi3:before {
  content: "\e6a4";
}

.wack-yun1:before {
  content: "\e6aa";
}

.wack-xue:before {
  content: "\e6ab";
}

.wack-lei:before {
  content: "\e6ad";
}

.wack-feng:before {
  content: "\e6ae";
}

.wack-qing:before {
  content: "\e752";
}
.wack-yuyin:before {
  content: "\e697";
}
.wack-kaiguanswitch-jibenzhuangtai-ximiezhuangtai:before {
  content: "\e69e";
}
.wack-kaiguanguanbi:before {
  content: "\e6ce";
}

.wack-kaiguan_:before {
  content: "\e69d";
}
.wack-fanhui:before {
  content: "\e65b";
  font-size: 24px !important;
  position: absolute;
  left: 10px;
  top: 0
}
.wack-dianhua8:before {
  content: "\e679";
}

.wack-ditu:before {
  content: "\e7bf";
}

.wack-gongnengshengji:before {
  content: "\e698";
}

.wack-qita:before {
  content: "\e699";
}
.wack-fankui:before {
  content: "\e8db";
}
.wack-jianjie1:before {
  content: "\e694";
}
.wack-test:before {
  content: "\e676";
}
.wack-switch-open2:before {
  content: "\e677";
}
.wack-guan-copy:before {
  content: "\e67f";
}
.wack-kaiqi:before {
  content: "\e67b";
}
.wack-dingweiweizhi-copy:before {
  content: "\e675";
}
.wack-youkezhongxin:before {
  font-size: 18px;
  content: "\e6d9";
}
.wack-dizhi3:before {
  content: "\e673";
}

.wack-shijian:before {
  content: "\e6a6";
}
.wack-dizhi4:before {
  content: "\e674";
}
.wack-guanbi1:before {
  content: "\e629";
  font-size: 28px;
}
.wack-guanbi1 {
  position: absolute;
  right: 13px;
  top: 0px;
}
.wack-jianjie:before {
  content: "\e670";
}

.wack-bangzhu:before {
  content: "\e671";
}
.wack-jingdian:before {
  font-size: 18px;
  content: "\e693";
}
.wack-churukou-copy:before {
  font-size: 18px;
  content: "\e66d";
}
.wack-luxian:before {
  font-size: 18px;
  content: "\e6a8";
}
.wack-shoupiao:before {
  font-size: 18px;
  content: "\e66e";
}  
</style>


// WEBPACK FOOTER //
// src/components/iconx.vue